var render = function (_h,_vm) {var _c=_vm._c;return _c('transition',{attrs:{"name":_vm.props.animation || 'slidedown',"appear":"","mode":"out-in"}},[_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68a72026","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./sportspower/assets/es6/components/Fader.vue
// module id = 47
// module chunks = 0